import {DragAndDropMoveModal} from './DragAndDropMoveModal'
import {SortableListContainer} from './SortableListContainer'
import {SortableListItem} from './SortableListItem'
import {SortableListTrigger} from './SortableListTrigger'

/**
 * Wrapper for the sortable list and item components.
 */
export const DragAndDrop = Object.assign(SortableListContainer, {
  Item: SortableListItem,
  MoveModal: DragAndDropMoveModal,
  Trigger: SortableListTrigger,
})

try{ DragAndDrop.displayName ||= 'DragAndDrop' } catch {}